var path = 'src/app/forms/fields/cohort-field.html';
var html = "<select frm-model frm-required ng-model=model ng-options=\"x as x.shortName for x in cohorts track by x.id\" ng-required=required() class=form-control> <option></option> </select> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/forms/fields/cohort-field.html
 ** module id = 255
 ** module chunks = 0
 **/